/**
 * JWT payload decoding helpers.
 *
 * Kept dependency-free (no storage/network) so the parsing logic — which runs
 * on every effect that needs `org_id`/`iss` — can be unit-tested directly and
 * is guaranteed never to throw on a malformed token.
 */

/**
 * Decode the JSON payload (middle segment) of a JWT WITHOUT verifying its
 * signature.
 *
 * Returns `undefined` for any unusable input — missing token, missing payload
 * segment, invalid base64, or non-JSON payload — so callers can treat the
 * result as "no session" and bail instead of crashing. A real, well-formed
 * token returns the parsed claims object.
 */
export function decodeJWTPayload(token: string | null | undefined): any {
  if (!token) return undefined;

  const segment = token.split(".")[1];
  if (!segment) return undefined;

  try {
    return JSON.parse(window.atob(segment));
  } catch {
    return undefined;
  }
}
